module.exports = __webpack_public_path__ + "img/background.230a2321.png";